import React from 'react';
import { buyedPointsStyle as styles } from '../../purchaseHistory.tailwind';
import { connect, useSelector } from 'react-redux';
import BuyedPointCard from './BuyedPointCard';
import { getUserBuyedPoints } from '../../../../redux/slices/purchaseHistorySlice';
import BottomPagination from '../../../shared/Pagination/BottomPagination/BottomPagination';

const BuyedPoints = ({ getUserPoints, fromDate, toDate }) => {
  const { buyedPoints } = useSelector((state) => state.purchaseHistory);
  // Use the pagePages (total pages) for pagination
  const totalPages = buyedPoints?.pagePages || 1;

  // const [currentPage, setCurrentPage] = useState(buyedPoints?.pageNumber || 1);

  const handleApiCall = async (value) => {
    // Fetch data for the current page whenever the page number changes
    const data = {
      page: value.toString(),
    }

    if(fromDate) {
      data.dateFromFilter = fromDate;
    }
    if(toDate) {
      data.dateToFilter = toDate;
    }

    const _response = await getUserPoints(data);

    if (getUserBuyedPoints.fulfilled.match(_response)) {
      // Scroll Top
      window.scrollTo(0, 0);
    }
  }

  // Handle page change
  const handlePageChange = (event, value) => {
    event.preventDefault();
    handleApiCall(value);
  };

  return (
    <div className={styles.innerContainer}>
      {/* Purchase History List */}
      <div className={styles.purchaseHistoryContainer}>
        {buyedPoints?.purchasedPoints?.map((purchase, index) => (
          <BuyedPointCard key={index} purchase={purchase} />
        ))}
      </div>

      {/* Pagination */}
      {buyedPoints?.purchasedPoints && totalPages > 1 && (
        <BottomPagination
          totalPages={totalPages}
          currentPage={buyedPoints?.pageNumber || 1}
          onPageChange={handlePageChange}
        />
      )}
    </div>
  );
};

const mapDispatchToProps = (dispatch) => {
  return {
    getUserPoints: (page) => dispatch(getUserBuyedPoints(page)),
  }
}

export default connect(null, mapDispatchToProps)(BuyedPoints);
// export default BuyedPoints;